import { atom } from 'jotai'

export const solanaAlphaRiskModalOpenAtom = atom<boolean>(false)
